import { baseAPI } from '~shared/api/base-api';

export interface ExportVolunteerReportParams {
  recitalId: string;
  format?: 'csv' | 'pdf';
}

export const exportVolunteerReport = async ({
  recitalId,
  format = 'csv',
}: ExportVolunteerReportParams): Promise<Blob> => {
  const response = await baseAPI.get(
    `/recitals/${recitalId}/reports/volunteers`,
    {
      params: { format },
      responseType: 'blob',
    },
  );
  return response.data;
};

export const downloadVolunteerReport = async (
  recitalId: string,
  format: 'csv' | 'pdf' = 'csv',
): Promise<void> => {
  const blob = await exportVolunteerReport({ recitalId, format });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `volunteer-report-${recitalId}.${format}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
